import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { NotificationProvider, AuthProvider, Login, Register, Verify, LupaPassword } from "@vionixasia/shared-components";

import { Beranda } from "./Beranda";
import { Layout } from "./components/Layout";

import {
  Profile,
  KebijakanPrivasi,
  PrivacyPolicyTracker,
  SyaratKetentuan,
  Kontak,
} from "@vionixasia/shared-components";

// Lazy-load pages that belong to livetrack-frontend (kept inside this package)

const EventMapPage = lazy(() => import("./pages/EventMapPage"));
const EventsPage = lazy(() => import("./pages/EventsPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const LiveMapPage = lazy(() => import("./pages/LiveMapPage"));
const EventHistoryPage = lazy(() => import("./pages/EventHistoryPage")); // New
const DeviceDetailPage = lazy(() => import("./pages/DeviceDetailPage"));
const DeviceHistoryPage = lazy(() => import("./pages/DeviceHistoryPage"));

const TrackerAssignmentPage = lazy(() => import("./pages/TrackerAssignmentPage"));
import AdminRoute from "./components/AdminRoute";

// Komponen untuk halaman 404
const NotFound = () => (
  <section className="w-full min-h-screen py-20 text-center text-slate-700 flex-col justify-center relative bg-white flex">
    <h2 className="text-xl sm:text-2xl md:text-3xl font-normal uppercase mb-2 text-slate-700 tracking-widest">
      PAGE
    </h2>
    <p className="text-4xl sm:text-5xl md:text-7xl font-black mx-auto mb-10 text-slate-700 px-4">
      NOT FOUND
    </p>

    <p className="text-lg text-slate-500 mb-10 px-6">
      The page you are looking for doesn’t exist or has been moved.
    </p>
  </section>
);

/* (Optional) Loading Fallback */
const LoadingFallback = () => (
  <div className="w-full min-h-screen flex items-center justify-center bg-white">
    <div className="text-center text-slate-700">
      <p className="text-xl font-semibold">Loading...</p>
    </div>
  </div>
);

const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>

        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              {/* Rute Utama */}
              <Route index element={<Beranda />} />

              {/* Event & Admin */}
              <Route path="event/:slug" element={<EventMapPage />} />
              <Route path="map/:slug" element={<EventMapPage />} />
              <Route path="map/:slug/history" element={<EventHistoryPage />} />
              <Route path="events" element={<EventsPage />} />
              <Route path="admin/*" element={<AdminRoute><AdminPage /></AdminRoute>} />

              {/* Live Tracking (lokal di livetrack-frontend) */}
              <Route path="live" element={<LiveMapPage />} />
              <Route path="device/:imei" element={<DeviceDetailPage />} />
              <Route
                path="device/:imei/history"
                element={<DeviceHistoryPage />}
              />
              
              {/* Tracker Assignment (QR Code Target) */}
              <Route path="assign/:imei" element={<TrackerAssignmentPage />} />

              {/* Profile & Info Pages (need Layout) */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/Profile" element={<Profile />} />
              <Route path="/KebijakanPrivasi" element={<PrivacyPolicyTracker />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyTracker />} />
              <Route path="/SyaratKetentuan" element={<SyaratKetentuan />} />
              <Route path="/Kontak" element={<Kontak />} />

              {/* Rute 404 */}
              <Route path="*" element={<NotFound />} />
            </Route>
            
            {/* Auth Routes Using Shared Components (Diluar Layout) */}
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="verify" element={<Verify />} />
            <Route path="lupapassword" element={<LupaPassword />} />

          </Routes>
        </Suspense>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
